/* src/app/shared/components/asc-desc-icon/asc-desc-icon.component.scss */
.background-container {
  border-radius: 24px;
  display: flex;
  flex-direction: row;
  height: 204px;
  width: 295px;
  min-width: 200px;
  padding-left: 24px;
  justify-content: space-between;
}
.grey-description-text {
  font-family: "Poppins-Regular";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  display: flex;
  align-items: center;
  color: #a6a6a6;
}
.white-description-text {
  font-family: "Poppins-Regular";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  display: flex;
  align-items: center;
  color: #ffffff;
}
.icon-image {
  padding-right: 130px;
  margin-top: 24px;
  margin-bottom: 24px;
  height: 56px;
  width: fit-content;
}
.percentage-inside-spinner {
  font-family: "Poppins-Regular";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #61566e;
}
.percentage-label {
  background: #f2f2f2;
  border-radius: 8px;
  flex: none;
  order: 1;
  flex-grow: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 2px 16px;
  gap: 4px;
  width: 58px;
  height: 20px;
  margin-top: 24px;
}
.percentage-amount {
  font-family: "Poppins-Regular";
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 130%;
  display: flex;
  align-items: center;
  text-transform: uppercase;
  color: #333333;
  flex: none;
  order: 0;
  flex-grow: 0;
}
h2 {
  font-family: "Poppins-Regular";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  color: #333333;
  margin-bottom: 0%;
}
h1 {
  padding-right: 16px;
  font-family: "Poppins-Regular";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 40px;
  display: flex;
  align-items: center;
  color: #333333;
  flex: none;
  order: 0;
  flex-grow: 0;
}
/*# sourceMappingURL=asc-desc-icon.component.css.map */
